// Alex Escobar Real State — main.js

// Search tabs
function setTab(btn) {
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}

// Mobile menu
function toggleMenu() {
  const menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.toggle('open');
}

// Search redirect
function doSearch() {
  const type = document.querySelector('.search-select')?.value || '';
  const location = document.querySelector('.search-input')?.value || '';
  const query = [type, location].filter(Boolean).join(' ');
  if (query) {
    window.location.href = '/collections/all?q=' + encodeURIComponent(query);
  }
}

// Highlight active nav link
document.addEventListener('DOMContentLoaded', () => {
  const path = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(link => {
    if (link.getAttribute('href') === path) link.classList.add('active');
  });
});
